const printImage = (url) => {
    const w = window.open('', '')
    w.document.write('<html><head>')
    w.document.write('</head><body >')
    w.document.write('<img id="print-image-element" src="' + url + '"/>')
    w.document.write('<script>const img = document.getElementById("print-image-element"); img.addEventListener("load",() => {window.focus(); window.print(); window.document.close(); window.close();});</script>')
    w.document.write('</body></html>')
}

export default printImage